module.exports = __webpack_public_path__ + "static/media/about-19.4f34e06b.png";